const normalizePrintValue = (value) => {
  if (value === null || value === undefined) return "";
  const normalized = String(value).trim();
  return ["null", "undefined"].includes(normalized.toLowerCase())
    ? ""
    : normalized;
};

export const getPrintOrderContext = ({
  items = [],
  customerName,
  customerPhone,
  customerAddress,
  deliveryTime,
  tableName,
}) => {
  const firstItem = items[0] || {};

  return {
    customerName: normalizePrintValue(
      customerName || firstItem.customer_name,
    ),
    customerPhone: normalizePrintValue(
      customerPhone || firstItem.phone,
    ),
    customerAddress: normalizePrintValue(
      customerAddress ||
        firstItem.customer_address ||
        firstItem?.bill?.shippingOrder?.receiver_address,
    ),
    deliveryTime: normalizePrintValue(
      deliveryTime || firstItem.delivery_time,
    ),
    tableName: normalizePrintValue(tableName || firstItem.user_identify),
  };
};

